import { render, staticRenderFns } from "./LinkToSignup.vue?vue&type=template&id=c3f7dab0&scoped=true&"
import script from "./LinkToSignup.vue?vue&type=script&lang=js&"
export * from "./LinkToSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f7dab0",
  null
  
)

export default component.exports